import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { LicenseTypesComponent } from './license-types.component'
import { CreateLicenseTypeComponent } from './create-license-type/create-license-type.component'
import { UpdateLicenseTypeComponent } from './update-license-type/update-license-type.component'
import { licenseTypesRoutes } from './license-types.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    LicenseTypesComponent,
    CreateLicenseTypeComponent,
    UpdateLicenseTypeComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(licenseTypesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [
    LicenseTypesComponent,
    CreateLicenseTypeComponent,
    UpdateLicenseTypeComponent,
  ],
})
export class LicenseTypesModule {}
